import BaseModelAPI from '../BaseModelAPI';

export default class OutgoingCheck extends BaseModelAPI {
	static entity = 'newobject1928';
	static entityName = 'outgoingcheck';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.outgoingCheckNumber = '';
			this.id = '';
			this.deliveryInstructionId = '';
			this.deliveryInstruction = {};
			this.processById = '';
			this.processBy = {};
			this.processDate = '';
			this.outgoingCheckStatusId = '';
			this.outgoingCheckStatus = {};
			this.outgoingCheckDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}